export default __webpack_public_path__ + "static/media/plus.f0e6f72b.svg";